<template>
  <el-card shadow="never" class="aui-card--fill">
    <div class="mod-decoration__manualconfig">
      <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
        <el-form-item label="学期" prop="termTableId">
          <el-select v-model="dataForm.termTableId" placeholder="学期表">
            <el-option v-for="table in termTableList" :key="table.id" :label="table.termName" :value="table.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="年级" prop="gradeId">
          <el-select v-model="dataForm.gradeId" placeholder="年级">
            <el-option v-for="grade in gradeList" :key="grade.id" :label="grade.title" :value="grade.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="id">
          <el-select v-model="dataForm.classId" placeholder="请选择班级" clearable filterable>
            <el-option v-for="classManager in classList" :label="classManager.className" :value="classManager.id"
              :key="classManager.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-input v-model="dataForm.studentName" placeholder="学生姓名" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="getList()">{{ $t('query') }}</el-button>
        </el-form-item>
        <!--  <el-form-item>
          <el-button type="info" @click="exportHandle()">{{ $t('export') }}</el-button>
        </el-form-item>-->
        <el-form-item>
          <el-button v-if="$hasPermission('decoration:manualConfig:save')" type="primary"
            @click="addOrUpdateHandle()">手册设置</el-button>
        </el-form-item>
        <el-form-item>
          <el-button v-if="$hasPermission('decoration:manualConfig:save')" type="primary"
            @click="exportHandle()">导出设置</el-button>
        </el-form-item>
        <el-form-item>
          <el-button v-if="$hasPermission('decoration:manualConfig:exportImg')" type="primary"
            @click="exportImg()">导出任务图片</el-button>
        </el-form-item>
        <el-form-item>
          <el-button v-if="$hasPermission('decoration:manualConfig:getStatisticsNumberOfDisputesByClass')" type="primary"
            @click="exportSheet()">获章汇总表</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getClassProgress()">班级争章进度</el-button>
        </el-form-item>
      </el-form>
      <el-table v-loading="dataListLoading" :data="dataList" border @selection-change="dataListSelectionChangeHandle"
        style="width: 100%;">
        <el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column>
        <el-table-column prop="setNum" label="座号" header-align="center" align="center"></el-table-column>
        <el-table-column prop="className" label="班级名" header-align="center" align="center"></el-table-column>
        <el-table-column prop="studentName" label="学生名" header-align="center" align="center"></el-table-column>
        <el-table-column label="基础章" header-align="center" align="center">
          <el-table-column v-for="(item, index) in decorationList" :key="index" :label="item.decorationName"
            header-align="center" align="center">
            <template slot-scope="scope">
              <img src="@/assets/img/success.png" v-if="scope.row.decorationMap[item.decorationId] === 1"
                style="height:24px;width: 24px;" alt="">

            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column v-if="isLike == 1" prop="likeNum" label="点赞数量" header-align="center"
          align="center"></el-table-column>
        <el-table-column v-if="isStar == 1" prop="starNum" label="评星数量" header-align="center"
          align="center"></el-table-column>
        <el-table-column :label="$t('handle')" fixed="right" header-align="center" align="center" width="150">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="viewHandle(scope.row)">查看手册</el-button>
            <el-button v-if="$hasPermission('decoration:manualconfig:update')" type="text" size="small"
              @click="addOrUpdateHandle(scope.row.id)">{{ $t('update') }}</el-button>
            <el-button v-if="$hasPermission('decoration:manualconfig:delete')" type="text" size="small"
              @click="deleteHandle(scope.row.id)">{{ $t('delete') }}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- <el-pagination
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="limit"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle">
      </el-pagination>-->
      <!-- 弹窗, 新增 / 修改 -->
      <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
      <exportconfig-add-or-update v-if="exportVisible" ref="exportconfigAddOrUpdate"></exportconfig-add-or-update>
      <view-manual v-if="viewVisible" ref="viewManual"></view-manual>
      <class-decoration-progress v-if="progressVisible" ref="classProgress"></class-decoration-progress>
      <el-dialog title="选择导出图片的方式" :visible.sync="open" width="30%" append-to-body>
        <template>
          <el-radio v-model="type" label="0">以班级分类导出</el-radio>
          <el-radio v-model="type" label="1">以奖章分类导出</el-radio>
        </template>
        <span slot="footer" class="dialog-footer">
          <el-button @click="open = false">取 消</el-button>
          <el-button type="primary" @click="exportImgFromType()">确定</el-button>
        </span>
      </el-dialog>
    </div>
  </el-card>
</template>

<script>
import { addDynamicRoute } from '@/router'
import mixinViewModule from '@/mixins/view-module'
import AddOrUpdate from './manualconfig-add-or-update'
import ExportconfigAddOrUpdate from './exportconfig-add-or-update'
import ViewManual from './view-manual'
import { Loading } from 'element-ui'
import Cookies from 'js-cookie'
import qs from 'qs'
import ClassDecorationProgress from './class-decoration-progress'
export default {
  mixins: [mixinViewModule],
  data() {
    return {
      mixinViewModuleOptions: {
        getDataListURL: '/decoration/manualconfig/page',
        getDataListIsPage: true,
        exportURL: '/decoration/manualconfig/export',
        exportImgURL: '/decoration/manualConfig/exportImg',
        deleteURL: '/decoration/manualconfig',
        deleteIsBatch: true,
        createdIsNeed: false,
        activatedIsNeed: false
      },
      decorationList: [],
      gradeList: [],
      termTableList: [],
      dataList: [],
      classList: [],
      exportVisible: false,
      viewVisible: false,
      progressVisible: false,
      termName: '',
      termId: '',
      dataForm: {
        termTableId: '',
        classId: '',
        gradeId: '',
        studentName: '',
        type: 0
      },
      isLike: undefined,
      isStar: undefined,
      open: false,
      type:0
    }
  },
  mounted() {
    this.getTableList()
    this.getRule()
  },
  methods: {
    // init () {
    //   this.visible = true
    //   this.$nextTick(() => {
    //     this.getDataList()
    //   })
    // },
    getRule() {
      this.$http
        .get(
          'decoration/medalrule/query'
        )
        .then(({ data }) => {
          if (data.code !== 0) {
            return this.$message.error(data.msg)
          }
          this.isLike = data.data.isLike
          this.isStar = data.data.isStar
        })
    },
    getTermStatistics() {
      this.$http
        .get(
          '/decoration/studentTermTable/getTermStatistics', {
          params: {
            termTableId: this.dataForm.termTableId,
            gradeId: this.dataForm.gradeId,
            classId: this.dataForm.classId,
            studentName: this.dataForm.studentName
          }
        }
        )
        .then(({ data }) => {
          if (data.code !== 0) {
            return this.$message.error(data.msg)
          }
          this.dataList = data.data
        })
    },
    getInfoList() {
      this.$http
        .get(
          '/decoration/studentDecoration/getDecorationList', { params: { termTableId: this.dataForm.termTableId, gradeId: this.dataForm.gradeId } }
        )
        .then(({ data }) => {
          if (data.code !== 0) {
            return this.$message.error(data.msg)
          }
          this.decorationList = data.data
        })
    },
    getList() {
      this.getInfoList()
      this.getTermStatistics()
    },
    getTableList() {
      this.getGradeList()
      this.$http
        .get(
          '/decoration/termTable/getList'
        )
        .then(({ data }) => {
          if (data.code !== 0) {
            return this.$message.error(data.msg)
          }
          this.termTableList = data.data
          if (this.termTableList.length > 0) {
            this.dataForm.termTableId = this.termTableList[0].id
          }
          if (this.dataForm.termTableId !== null && this.dataForm.termTableId !== '' && this.dataForm.gradeId !== null && this.dataForm.gradeId !== '') {
            this.getList()
          }
        })
    },
    getGradeList() {
      this.$http.get('/grade/getList').then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.gradeList = res.data
        if (this.gradeList.length > 0) {
          this.dataForm.gradeId = this.gradeList[0].id
        }
      })
      this.$nextTick(() => {
        this.getClassList()
      })
    },
    exportHandle() {
      this.exportVisible = true
      this.$nextTick(() => {
        this.$refs.exportconfigAddOrUpdate.init()
      })
    },
    getClassProgress() {
      this.progressVisible = true
      this.$nextTick(() => {
        this.$refs.classProgress.termTableId = this.dataForm.termTableId
        this.$refs.classProgress.init()
      })
    },
    exportImg() {
      this.open = true
      // const loadingInstance = Loading.service(this.loadOptions)
      // // 数据量巨大一个小时
      // this.$http.timeout = 1000 * 60 * 60 * 60
      // this.$http
      //   .post('decoration/manualConfig/batchZipExport', this.dataForm)
      //   .then(({ data: res }) => {
      //     loadingInstance.close()

      //     if (res.code !== 0) {
      //       return this.$message.error(res.msg)
      //     }
      //     const filePath = res.data
      //     const params = qs.stringify({
      //       filePath: res.data,

      //       token: Cookies.get('token')
      //     })
      //     window.open(
      //       `${window.SITE_CONFIG.apiURL}/decoration/manualConfig/getBatchExportFile?${params}`
      //     )
      //     this.$message({
      //       message: this.$t('prompt.success'),
      //       type: 'success',
      //       duration: 500,
      //       onClose: () => {
      //         this.visible = false
      //         this.$emit('refreshDataList')
      //       }
      //     })
      //   })
      //   .catch((e) => {
      //     console.log('~~~~~~~~~~',e)
      //     loadingInstance.close()
      //     return this.$message.error('批量导出失败')
      //   })
    },
    exportImgFromType() {
      const loadingInstance = Loading.service(this.loadOptions)
      // 数据量巨大一个小时
      this.$http.timeout = 1000 * 60 * 60 * 60
      const params = {
        termTableId: this.dataForm.termTableId, 
          gradeId: this.dataForm.gradeId,
        classId: this.dataForm.classId,
        studentName: this.dataForm.studentName,
        type: this.type
        }
      this.$http
        .post('decoration/manualConfig/batchZipExport',params)
        // this.dataForm)
        .then(({ data: res }) => {
          loadingInstance.close()

          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          const filePath = res.data
          const params = qs.stringify({
            filePath: res.data,

            token: Cookies.get('token')
          })
          window.open(
            `${window.SITE_CONFIG.apiURL}/decoration/manualConfig/getBatchExportFile?${params}`
          )
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.visible = false
              this.$emit('refreshDataList')
            }
          })
        })
        .catch((e) => {
          console.log('~~~~~~~~~~',e)
          loadingInstance.close()
          return this.$message.error('批量导出失败')
        })
    },
    exportSheet() {
      this.$nextTick(() => {
        // 路由参数
        const routeParams = {
          routeName: `${this.$route.name}decoration/summary-sheet`,
          title: '获章汇总表',
          path: 'decoration/summary-sheet'

        }
        // 动态路由
        addDynamicRoute(routeParams, this.$router)
      })
    },
    viewHandle(row) {
      this.viewVisible = true
      this.termName = this.termTableList.filter((e) => { return e.id === this.dataForm.termTableId })[0].termName
      this.termId = this.termTableList.filter((e) => { return e.id === this.dataForm.termTableId })[0].termId
      console.log(this.termName)
      this.$nextTick(() => {
        this.$refs.viewManual.studentName = row.studentName
        this.$refs.viewManual.studentSex = row.studentSex
        this.$refs.viewManual.className = row.className
        this.$refs.viewManual.classId = row.classId
        this.$refs.viewManual.headTeacherName = row.headTeacherName
        this.$refs.viewManual.dataForm.studentId = row.studentId
        this.$refs.viewManual.schoolId = row.schoolId
        this.$refs.viewManual.studentId = row.studentId
        this.$refs.viewManual.termName = this.termName
        this.$refs.viewManual.dataForm.termId = this.termId
        this.$refs.viewManual.init()
      })
    },
    getClassList() {
      this.$http.get('/classmanage/classmanage/getList', {
        params: {
          gradeId: this.dataForm.gradeId
        }
      }).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.classList = res.data
      }).catch(() => {
      })
    }
  },
  watch: {
    'dataForm.gradeId'() {
      this.dataForm.classId = ''
      this.getClassList()
    }
  },
  components: {
    ClassDecorationProgress,
    ExportconfigAddOrUpdate,
    ViewManual,
    AddOrUpdate
  }
}
</script>
<style scoped>
.el-form--inline .el-form-item {
  margin-right: 8px;
}
</style>
